export const extractErrorMessages = (errors, touched)=>Object.keys(errors).filter((name)=>touched[name] || name.startsWith('FINAL_FORM/')).reduce((errorMessages, name)=>({
            ...errorMessages,
            [name]: errors[name]
        }), {});
export const transformErrorMessage = (errors)=>{
    const valueMap = {};
    Object.entries(errors).forEach(([key, value])=>{
        valueMap[value] ??= [];
        valueMap[value].push(key);
    });
    return Object.entries(valueMap).map(([value, keys])=>`> ${value}: ${keys.join(', ')}`).join('  ');
};

//# sourceMappingURL=errors.js.map